module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-CN":{"title":"撰写其他评价","expected_reward":"最高可获得 {0}"}}')
  delete Component.options._Ctor
}
